// WelcomeSection.js
import { Col } from "reactstrap";
import strings from "../../../utils/Strings";
import "../styles/LoginStyle.css";

// icons
import learningPathIcon from "../assets/Frame 2147227416.svg";
import progressIcon from "../assets/Frame 2147227417.svg";
import certificationIcon from "../assets/Frame 2147227418.svg";

function WelcomeComponent() {
  return (
    <Col
      lg={6}
      className="d-flex flex-column justify-content-center v2-login-welcome-wrapper"
    >
      {/* badge */}
      <div className="v2-login-badge">• TRUSTED BY 50,000+ LEARNERS</div>

      {/* heading */}
      <h1 className="v2-login-title">
        Upskill to be <br />
        <span>Future Ready</span>
      </h1>

      {/* description */}
      <p className="v2-login-description">
        The modern workspace moves fast. Jozuna provides the tools and community
        you need to master new skills through smart evaluations.
      </p>

      {/* features */}
      <div className="v2-login-feature-list">
        <div className="v2-login-feature-item">
          <div className="v2-login-feature-icon">
            <img src={learningPathIcon} alt="Learning Path" />
          </div>

          <div>
            <h6>Personalized learning paths</h6>
            <p>Tailored to your role, pace and goals</p>
          </div>
        </div>

        <div className="v2-login-feature-item">
          <div className="v2-login-feature-icon">
            <img src={progressIcon} alt="Progress" />
          </div>

          <div>
            <h6>Progress that's visible</h6>
            <p>Track skills and milestones in real time</p>
          </div>
        </div>

        <div className="v2-login-feature-item">
          <div className="v2-login-feature-icon">
            <img src={certificationIcon} alt="Certification" />
          </div>

          <div>
            <h6>Recognized certifications</h6>
            <p>Credentials employers actually trust</p>
          </div>
        </div>
      </div>
    </Col>
  );
}

export default WelcomeComponent;
